module.exports = __webpack_public_path__ + "static/media/ring_central_promo.240570b3.jpg";